import { observer } from "mobx-react-lite";
import updateIcon from "images/update.svg";
import { Tooltip, Button } from "antd";

import styles from "./syncButton.module.css";
import { useState } from "react";
import { getBidBalance } from "services";
import { useStores } from "stores";
import { useNotificationContext } from "providers";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { parseErrorMessage } from "utils";

export const SyncBalanceButton = observer(() => {
  const { bidCard } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const handleUpdateBalance = async () => {
    setLoading(true);
    await getBidBalance({ id: bidCard.bid.id })
      .then(() => {
        setTimeout(() => {
          setLoading(false);
          bidCard.updateCardById(bidCard.bid.id);
        }, 1500);
      })
      .catch((e) => {
        openNotification({
          type: NOTIFICATION_TYPE_ENUM.ERROR,
          description: parseErrorMessage(e),
        });
        setLoading(false);
      });
  };
  return (
    <Tooltip title="Обновить балансы" className={styles.syncButton}>
      <Button type="text" size="large" onClick={handleUpdateBalance} loading={loading}>
        <img src={updateIcon} className={`${styles.syncIcon} square icon-3xl grey-border`}  />
      </Button>
    </Tooltip>
  );
});
